import { render } from "./description-block.vue?vue&type=template&id=456f449f"
import script from "./description-block.vue?vue&type=script&lang=js"
export * from "./description-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__